import React, { FC } from 'react';
import { Hyperlink } from '../../components/Hyperlink';
import { InsightsBox } from '../../components/insights-box/InsightsBox';
import { DecisionSeparator } from '../components/decision-separator/DecisionSeparator';
import styles from './decision_keywords.module.scss';
import { withUser } from '../../user/UserContext';
import {
  withRestrictedModal,
  WithRestrictedModalProps,
} from '../../components/modal/components/modal-restricted/withRestrictedModal';
import { UserContextType } from '../../user/user.types';
import { getPageName } from '../../utils/pageName';
import { buildUrlWithParameters } from '../../utils/url-utils/urlUtils';

type Props = UserContextType &
  WithRestrictedModalProps & {
    keywords: Array<{
      html: string;
      label: string;
      id: number;
    }>;
    target?: string;
  };

export const RawDecisionKeywords: FC<Props> = ({
  keywords,
  accessPremium,
  openRestrictedModal,
  target = '',
}) => {
  const source = 'search_by_keyword_from_excerpt';
  const pageName = getPageName();

  if (!keywords.length) {
    return null;
  }

  return (
    <InsightsBox>
      <ul className={styles.wrapper}>
        {keywords.map((keyword, index) => (
          <li key={keyword.id} className={styles.item}>
            <Hyperlink
              className={styles.link}
              dangerouslySetInnerHTML={{ __html: keyword.html }}
              {...(!accessPremium
                ? {
                    onClick: () => openRestrictedModal(source),
                  }
                : {
                    href: buildUrlWithParameters('/search', {
                      q: encodeURIComponent(keyword.label),
                      source,
                      sourcePage: pageName,
                    }),
                    target,
                  })}
            />
            {index < keywords.length - 1 && <DecisionSeparator />}
          </li>
        ))}
      </ul>
    </InsightsBox>
  );
};

export const DecisionKeywords = withUser(
  withRestrictedModal(RawDecisionKeywords),
);
